export default "__VITE_ASSET__Cftrs0HO__"